import { Fragment } from "react";
import { Box, Grid } from "@mui/material";

import { Breadcrumbs, PageHeader, Spinner } from "@dzambalaorg/mui-page-layout";
import { RichTextDisplay } from "@dzambalaorg/mui-rte";
import type { IMerge } from "@framework/types";
import { useFetchData } from "@dzambalaorg/react-hooks";

import { MergeItemPanel } from "../merge-item-panel";
import { StyledDescription, StyledImageList, StyledImageListItem } from "../../../../../../components/styled";

export const MergeItem = () => {
  const { data, isLoading } = useFetchData<IMerge>("/recipes/merge");

  if (isLoading) {
    return <Spinner />;
  }

  if (!data) {
    // TODO - [AFTER ALL REFACTORING] - add universal no data component
    return <div>No data</div>;
  }

  return (
    <Fragment>
      <Breadcrumbs
        path={["dashboard", "recipes", "recipes.merge"]}
        data={[{}, {}, { title: data.item?.components.map(comp => comp.template?.title).join(" + ") }]}
      />

      <PageHeader
        message="pages.recipes.merge.title"
        data={{ title: data.item?.components.map(comp => comp.template?.title).join(" + ") }}
      />

      <Grid container>
        <Grid size={{ xs: 12, sm: 9 }}>
          <StyledImageList count={data.item?.components.length || 1}>
            {data.item?.components.map(component => {
              return (
                <StyledImageListItem key={component.template!.id}>
                  <Box component="img" src={component.template!.imageUrl} alt="Cascadify template image" />
                </StyledImageListItem>
              );
            })}
          </StyledImageList>
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <MergeItemPanel merge={data} />
        </Grid>
      </Grid>

      <StyledDescription>
        <RichTextDisplay data={data.item?.components[0].template!.description} />
      </StyledDescription>
    </Fragment>
  );
};
